import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-start flex-column mb-3"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "my-0" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center mb-3"
}
const _hoisted_7 = { class: "my-0" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6 col-md-9 col-lg-6 ps-0" }
const _hoisted_10 = { class: "d-flex flex-wrap" }
const _hoisted_11 = { class: "small col-12 col-md-6 col-lg-12" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "col-6 col-md-3 col-lg-6" }
const _hoisted_16 = {
  key: 0,
  class: "lp-location_tag-list"
}
const _hoisted_17 = { class: "small py-0 my-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lp-location",
    id: 'location-' + $props.location.Id,
    key: `location-${String($props.index)}`
  }, [
    ($props.location.Url && $props.enableDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            class: "lp-location-details",
            href: $options.getDetailsPageUrl
          }, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString($props.location.DisplayName), 1)
          ], 8, _hoisted_3),
          ($props.filterByDistanceFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.location.Distance.toFixed(2)) + " mi", 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h5", _hoisted_7, _toDisplayString($props.location.DisplayName), 1)
        ])),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("address", _hoisted_11, [
            _createTextVNode(_toDisplayString($props.location.Street) + " ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString($props.location.City), 1),
            ($props.location.City && ($props.location.State || $props.location.Zip))
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, ","))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString($props.location.State) + " " + _toDisplayString($props.location.Zip) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("a", {
              href: `tel:${$props.location.Phone.replace(/[^0-9]/, '')}`,
              class: "lp-location-phone"
            }, _toDisplayString($setup.formatPhoneNumber($props.location.Phone)), 9, _hoisted_13)
          ]),
          _createElementVNode("div", {
            class: "col-12 col-md-6 col-lg-12",
            innerHTML: $props.location.Hours
          }, null, 8, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        ($props.location.CustomFilters.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.location.CustomFilters, (tag, index) => {
                  return (_openBlock(), _createElementBlock("li", null, _toDisplayString(tag.Title), 1))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, _hoisted_1))
}